import { memo, useCallback, useEffect, useState } from "react";
import axios from "axios";

import { API_URL } from "../../../../utils/constant";

function Index({ item: r, updateTicketFunction, OrgId: id, imgselect }) {
  const [users, setUsers] = useState([]);
  const [value, setValue] = useState({ value: "", isLoad: false });

  const fetchUsers = useCallback(async (OrgID, type) => {
    try {
      const response = await axios.get(
        `${API_URL}/user?id=${OrgID}&taskType=${type}`
      );
      if (response.data.error === false) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, []);

  useEffect(() => {
    if (id && (value?.value || "").trim().length > 0 && value?.isLoad) {
      fetchUsers(id, value?.value);
      setValue({ value: "", isLoad: false });
    }
  }, [id, r?.task, fetchUsers, value]);

  return (
    <>
      <td>
        <div className="select-box">
          <select
            className="select_box_mytask"
            value={r?.task}
            onChange={(e) => {
              let data = {
                task: e.target.value,
                organisationId: id,
              };
              setValue({ value: e.target.value, isLoad: true });
              updateTicketFunction(r?.recordId, data);
            }}
          >
            <option value="">Please select</option>
            <option value="External">External Task</option>
            <option value="Internal">Internal Task</option>
            <option value="Ticket">Ticket</option>
          </select>
          <div className="select_box_img">
            <img src={imgselect} alt="" />
          </div>
        </div>
      </td>
      <td>
        <div className="select-box">
          <select
            className="select_box_mytask"
            disabled={!r?.task}
            value={r?.assignedTo?._id || ""}
            onFocus={async () => {
              if (r?.task && (users || []).length <= 0) {
                await fetchUsers(id, r?.task);
              }
            }}
            onChange={(e) => {
              let data = {
                assignedTo: e.target.value,
                organisationId: id,
              };
              updateTicketFunction(r?.recordId, data);
            }}
          >
            <option value="">Please select</option>
            {(users || []).length <= 0 && r?.assignedTo?._id && (
              <>
                <option value={r?.assignedTo?._id} selected>
                  {r?.assignedTo?.fullName} ({r?.assignedTo?.email})
                </option>
              </>
            )}
            {(users || []).map((user) => (
              <option key={user._id} value={user._id}>
                {user.fullName} ({user.email})
              </option>
            ))}
          </select>
          <div className="select_box_img">
            <img src={imgselect} alt="" />
          </div>
        </div>
      </td>
    </>
  );
}

export default memo(Index);
